export default {
  title: 'Rejoignez {{name}} !',
  default_program_name: 'Club de fidélité',
  savings_highlight: {
    title: 'Soyez récompensé. À chaque commande, à chaque fois.',
    subtitle: 'Inscrivez-vous en quelques secondes et commencez à gagner des points.',
  },
  how_it_works: {
    label: 'Comment ça marche',
    step_1: {
      title: 'Inscrivez-vous en 30s',
      desc: 'Juste votre numéro de téléphone',
    },
    step_2: {
      title: 'Commandez & gagnez',
      desc: '{{percentage}}% remboursé sur chaque commande',
    },
    step_3: {
      title: 'Échangez & économisez',
      desc: "Jusqu'à {{amount}} de réduction par commande",
    },
  },
  profile: {
    verified_title: 'Téléphone vérifié !',
    verified_subtitle: 'Complétez votre profil pour commencer à gagner.',
  },
  form: {
    phone_number: {
      label: 'Numéro de téléphone',
      description: 'Nous vous enverrons un code de vérification pour confirmer votre identité.',
      placeholder: 'Numéro de téléphone',
    },
    birthday: {
      label: 'Anniversaire — le jour et le mois suffisent pour recevoir un cadeau 🥳',
      placeholder: 'Anniversaire (optionnel)',
      parts: {
        month: 'Mois',
        day: 'Jour',
      },
    },
  },
  terms:
    'En vous inscrivant, vous acceptez nos <TermsLink>conditions générales</TermsLink> et consentez à notre <PrivacyPolicyLink>politique de confidentialité</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Continuer',
    verify: 'Vérifier',
    complete: "Finaliser l'inscription",
  },
  toasts: {
    login_success: 'Vous avez été connecté avec succès',
    invalid_code: 'Code invalide. Veuillez réessayer.',
    failed_to_update_profile: 'Échec de la mise à jour du profil. Veuillez réessayer.',
  },
};
